import React from 'react';
import { clsx } from 'clsx';

export function Card({ className, ...props }) {
  return (
    <div
      className={clsx(
        "rounded-lg border-2 border-[#494646] bg-[#2a282a] text-slate-100 shadow-lg",
        className
      )}
      {...props}
    />
  );
}

export function CardHeader({ className, ...props }) {
  return (
    <div
      className={clsx("flex flex-col space-y-1.5 p-6", className)}
      {...props}
    />
  );
}

export function CardTitle({ className, ...props }) {
  return (
    <h3
      className={clsx(
        "text-2xl font-semibold leading-none tracking-tight",
        className
      )}
      {...props}
    />
  );
}

export function CardDescription({ className, ...props }) {
  return (
    <p
      className={clsx("text-sm text-slate-400", className)}
      {...props}
    />
  );
}

export function CardContent({ className, ...props }) {
  return <div className={clsx("p-6 pt-0", className)} {...props} />;
}

export function CardFooter({ className, ...props }) {
  return (
    <div
      className={clsx("flex items-center p-6 pt-0", className)}
      {...props}
    />
  );
}